module.exports = __webpack_public_path__ + "img/guide05.3f038072.png";